import React from 'react';
import './PrimaryText.css';

export const PrimaryText = ({ text, alignText = '' }) => <p className={`primaryText ${alignText}`}>{text}</p>;
